module.exports = __webpack_public_path__ + "media/images/redesign-images/how-it-works/icons/icon-how-embroidery-4009cc121b501692d5bfdbe822e2a5cd.svg";